import TableBlock from '../common/blocks/TableBlock';
const Fee = () => {
	return (
		<TableBlock/>	
	);
};
export default Fee;